import { Component } from '@angular/core';

@Component({
	templateUrl: './internalServerError.component.html'
})
export class InternalServerErrorComponent {}
